import { render, staticRenderFns } from "./IconArrowNarrowRightSolid.vue?vue&type=template&id=52245901"
import script from "./IconArrowNarrowRightSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowRightSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports